import React from "react";
import moment from "moment";
import {
    RenderKilogramo,
    RenderNumberPercentage,
} from "../../../../../../Utils/renderField/renderReadField";
import LoadMask from "../../../../../../Utils/LoadMask/LoadMask";
import NullableValue from "../../../../../../Utils/renderField/nullableValue";
import Paginacion from "../../../../../../Utils/Components/Paginacion/Paginacion";
import CardEmpty from "Utils/Cards/CardEmpty";
import { DecisionSwal } from "../../../../../../Utils/Utils/DecisionSwal";
import { MIGA_DESECHO_ESTADOS } from "../../../../../../../../utility/constants";
import { useHistorialMiga } from "../hooks/useHistorialMiga";
import { FiltroPadrePT } from "../../../../components/FiltroPadrePT/FiltroPadrePT";
import { ModalKgMiga } from "./ModalKgMiga";
const editarIcon = require("assets/img/icons/editar.png");
const eliminarIcon = require("assets/img/icons/borrar.png");

// Las semanas reportadas en 0 no tienen análisis, así que en su lugar se indica
// que no hubo miga que analizar. Una semana cancelada tampoco tiene análisis
// vigente, pero sí pudo haber reportado kilos, así que no se dice que no hubo
const RenderAnalisis = ({ registro }) => {
    if (registro.estado === MIGA_DESECHO_ESTADOS.CANCELADO) {
        return <span className="text-muted">Cancelado</span>;
    }

    if (!registro.analisis_drc) {
        return <span className="text-muted">Sin miga</span>;
    }

    if (registro.analisis_drc.drc === null) {
        return (
            <span className="text-muted">
                {registro.analisis_drc.estado_display}
            </span>
        );
    }

    return (
        <RenderNumberPercentage
            value={registro.analisis_drc.drc}
            decimalScale={3}
        />
    );
};

export const HistorialMigaDesecho = ({ tabActiva, regresar }) => {
    const hook = useHistorialMiga({ tabActiva });

    const ConfirmarCancelar = (registro) => {
        DecisionSwal(
            "¿Desea cancelar el reporte de miga de esta semana? La semana quedará nuevamente pendiente de reporte.",
            "Sí",
            "No",
            () => hook.CancelarReporte(registro.id),
        );
    };

    return (
        <div className="view__tab-wrapper">
            <LoadMask loading={hook.cargando} blur>
                <CardEmpty noShadow>
                    <FiltroPadrePT hook={hook} />

                    <div className="new-table-wrapper miga-desecho__table-wrapper">
                        <table className="table-striped">
                            <thead>
                                <tr>
                                    <th>FECHA DE REGISTRO</th>
                                    <th>PADRE PT</th>
                                    <th>SEMANA</th>
                                    <th>KILOS HÚMEDOS</th>
                                    <th>DRC</th>
                                    <th>KILOS SECOS</th>
                                    <th>ESTADO</th>
                                    <th>ACCIONES</th>
                                </tr>
                            </thead>
                            <tbody>
                                {hook.registros.length === 0 && (
                                    <tr>
                                        <td className="text-center" colSpan={8}>
                                            No se han reportado migas de desecho
                                        </td>
                                    </tr>
                                )}

                                {hook.registros.map((registro) => (
                                    <tr key={registro.id}>
                                        <td className="text-center text-nowrap">
                                            {registro.fecha_registro
                                                ? moment(
                                                      registro.fecha_registro,
                                                  ).format("DD/MM/YYYY")
                                                : ""}
                                        </td>
                                        <td className="text-center text-nowrap">
                                            {
                                                registro.padre_producto_terminado_nombre
                                            }
                                        </td>
                                        <td className="text-center text-nowrap">
                                            <div className="d-flex flex-column">
                                                <span>{`${registro.etiqueta} - ${registro.anio}`}</span>
                                                <small className="text-muted">
                                                    {registro.rango}
                                                </small>
                                            </div>
                                        </td>
                                        <td className="text-center text-nowrap">
                                            <RenderKilogramo
                                                value={registro.kg_humedos}
                                                decimalScale={2}
                                            />
                                        </td>
                                        <td className="text-center text-nowrap">
                                            <RenderAnalisis
                                                registro={registro}
                                            />
                                        </td>
                                        <td className="text-center text-nowrap">
                                            <NullableValue
                                                value={
                                                    registro.analisis_drc
                                                        ? registro.analisis_drc
                                                              .kg_secos
                                                        : null
                                                }
                                            >
                                                <RenderKilogramo
                                                    value={
                                                        registro.analisis_drc
                                                            ? registro
                                                                  .analisis_drc
                                                                  .kg_secos
                                                            : 0
                                                    }
                                                    decimalScale={3}
                                                />
                                            </NullableValue>
                                        </td>
                                        <td className="text-center text-nowrap">
                                            {registro.estado_display}
                                        </td>
                                        <td className="text-center text-nowrap">
                                            <div className="table-actions">
                                                {registro.puede_modificar ? (
                                                    <React.Fragment>
                                                        <img
                                                            src={editarIcon}
                                                            alt="Editar"
                                                            className="action_img"
                                                            title="Corregir los kilos húmedos"
                                                            onClick={() =>
                                                                hook.AbrirModalEdicion(
                                                                    registro,
                                                                )
                                                            }
                                                        />
                                                        <img
                                                            src={eliminarIcon}
                                                            alt="Cancelar"
                                                            className="action_img"
                                                            title="Cancelar el reporte"
                                                            onClick={() =>
                                                                ConfirmarCancelar(
                                                                    registro,
                                                                )
                                                            }
                                                        />
                                                    </React.Fragment>
                                                ) : (
                                                    <span>—</span>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                ))}

                                {hook.registros.length > 0 && (
                                    <tr className="modal-ingresos__totales-row">
                                        <td
                                            className="text-right text-nowrap"
                                            colSpan={3}
                                        >
                                            <strong>TOTALES:</strong>
                                        </td>
                                        <td className="text-center text-nowrap">
                                            <RenderKilogramo
                                                value={
                                                    hook.totales.kg_humedos || 0
                                                }
                                                decimalScale={2}
                                            />
                                        </td>
                                        <td></td>
                                        <td className="text-center text-nowrap">
                                            <RenderKilogramo
                                                value={
                                                    hook.totales.kg_secos || 0
                                                }
                                                decimalScale={3}
                                            />
                                        </td>
                                        <td colSpan={2}></td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    <Paginacion
                        cantidadResultados={hook.cantidadResultados}
                        paginaSeleccionada={hook.paginaSeleccionada}
                        setPaginaSeleccionada={hook.setPaginaSeleccionada}
                    />

                    <div className="d-flex justify-content-center mt-3 mb-3">
                        <button
                            className="btn btn-outline-dark"
                            onClick={regresar}
                        >
                            Regresar
                        </button>
                    </div>

                    {hook.registroEnEdicion && (
                        <ModalKgMiga
                            abierto={true}
                            onCerrar={hook.CerrarModalEdicion}
                            titulo="Corregir miga de desecho"
                            descripcion={`${hook.registroEnEdicion.etiqueta} del ${hook.registroEnEdicion.anio} · ${hook.registroEnEdicion.padre_producto_terminado_nombre}`}
                            kgHumedos={hook.kgHumedosInput}
                            setKgHumedos={hook.setKgHumedosInput}
                            onConfirmar={hook.EditarKg}
                            textoConfirmar="Guardar"
                            cargando={hook.cargando}
                        />
                    )}
                </CardEmpty>
            </LoadMask>
        </div>
    );
};
